const suggestItemType = {
  city: 'city',
  airport: 'airport',
  country: 'country',
};

export function prepareSuggestResult(data) {
  const { suggest = [], references = {} } = data;

  const { cities = {}, countries = {}, airports = {} } = references;

  const result = suggest
    .filter(suggestItem => suggestItem.type !== suggestItemType.country)
    .map(suggestItem => {
      // Выпилить когда бек перестанет конретинацию города (округа|аэропорта) страны
      const suggestStringParts = suggestItem.string.split(',');
      const suggestString = suggestStringParts.splice(0, suggestStringParts.length - 1).join(',');

      const item = {
        type: suggestItem.type,
        code: suggestItem.code,
        text: suggestString,
      };

      if (item.type === suggestItemType.city && cities[item.code]) {
        item.cityInfo = cities[item.code];
        item.name = item.cityInfo.name;
      }

      if (item.type === suggestItemType.airport && airports[item.code]) {
        item.airportInfo = airports[item.code];
        item.cityInfo = cities[item.airportInfo.parent];
        item.name = item.airportInfo.name;
      }

      if (countries[item.cityInfo.parent]) {
        item.country = countries[item.cityInfo.parent].name;
      }

      return item;
    });

  return result;
}
